export const getEnvironment = () => {
  const { hostname } = window.location;

  if (hostname.includes('eventwheel.international')) {
    return 'international';
  }

  if (hostname.includes('eventwheel.ru')) {
    return 'russia';
  }

  return 'development';
};
